/**
 * Nav Module
 * 
 * @description
 * <p>Sets up nav menus and events</p>
 * <p>On page load, caches DOM elements and adds menu and close button click events.</p>
 * <p>Self-initializes when you include this module.</p>
 *
 * @module nav
 * 
 * @namespace site.nav
 */
( /* @lends module:nav */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
        $dom = {},
        navOpen = false;

    /**
     * Nav Initializer
     */
	function init() {

        // register modules/libraries for local use
        trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

        
        // Cache DOM elements
        $dom.html = $("html");
        $dom.body = $("body");
        $dom.site = $("#site");
        $dom.nav = $("header");
        $dom.historyNav = $("#history-nav");
        $dom.navHolder= $(".nav-holder", $dom.nav);
        $dom.menuBtn = $(".menu-btn", $dom.nav);
        $dom.closeBtn = $(".close-btn", $dom.nav);

        listeners();
    }

    /**
     * All Global listeners registered here
     */
    function listeners() {
        $dom.menuBtn.on('click', function() {
            openMenu();
        });

        $dom.closeBtn.on('click', function() {
            closeMenu();
        });
    }
    
    /**
     * @public
     * @function site.nav.navOpen
     * @description Open the mobile Nav
     * @example
     * {@lang JavaScript}
     * site.nav.navOpen();
     */
    function openMenu() {
        trace.push('openMenu');

        navOpen = true;

        $dom.navHolder.addClass('active');
        $dom.menuBtn.removeClass('active');
        $dom.closeBtn.addClass('active');

        $dom.site.addClass('inactive');
        $dom.historyNav.addClass('inactive');
        site.lockScreen(); 
    }

    /**
     * @public
     * @function site.nav.closeMenu
     * @description Close the mobile Nav
     * @example
     * {@lang JavaScript}
     * site.nav.closeMenu();
     */
    function closeMenu() {
        trace.push('closeMenu');

        navOpen = false;

        $dom.navHolder.removeClass('active');
        $dom.menuBtn.addClass('active');
        $dom.closeBtn.removeClass('active');
        $dom.site.removeClass('inactive');
        $dom.historyNav.removeClass('inactive');
        site.unlockScreen()
    }


    // Public API definitions
    site.nav = {
        navOpen: navOpen,
        closeMenu: closeMenu
    };

	$(function(){
		init();
	});
	$('.terms-float-close').on('click', function() {
		$('.float-icon-bar').animate({
		  opacity: 'hide', // animate slideUp
		  right: '-100px',  // slide left
		}, 'slow', 'linear', function() {
			$(this).remove();
		});
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
